"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app = {
    SESSION_STORAGE: {
        IDENTITY_PROVIDER_INFO: 'Telematics.idp',
        LEGACY: {
            CAN_RESOLVE_FAULTS: 'Telematics.canResolveFaults',
            CLAIMS: 'Telematics.claims',
            HAS_SAFETY_SUBSCRIPTION: 'Telematics.hasSafetySubscription',
            HAS_FUEL_SUBSCRIPTION: 'Telematics.hasFuelSubscription',
            INFO_MODAL_VERSION_SEEN: 'Telematics.infoModalVersionSeen',
            IS_ADMIN: 'Telematics.isAdmin',
            IS_DTNA: 'Telematics.isDtna',
            IS_ROOT: 'Telematics.isRoot',
            IS_SAFETY: 'Telematics.isSafety',
            IS_CS_AGENT: 'Telematics.IsCsAgent',
            IS_CS_ADMIN: 'Telematics.IsCsAdmin',
            IS_OPS: 'Telematics.IsOps',
            IS_XOTA: 'Telematics.isXota',
            LOGIN_ATTEMPTED: 'Telematics.loginAttempted',
            LOGIN_ATTEMPTS: 'Telematics.loginAttempts',
            OID: 'Telematics.oid',
            PROFILE: 'Telematics.profile',
            POTA_MODAL_VERSION_SEEN: 'Telematics.potaModalVersionSeen',
            TAN_ID: 'Telematics.tanId',
            TAN_NAME: 'Telematics.tanName',
            TNAME_TABLES_MAIN_VEHICLES: 'Telematics.":tan_name".Tables.Main.Vehicles',
        },
        VEHICLE_LIST_FILTER_SELECTIONS: 'Telematics.vehicleList.filters',
        SWITCH_ACCOUNT_SEARCH_RESULTS: 'Telematics.switch-account-search-results',
        VIRTUAL_TECHNICIAN_CUSTOMER: 'VT',
        GLOBAL_EVENT: 'session-storage',
    },
    TABLE: {
        FAULTS: {
            TABLE_ID: 'faults',
        },
    },
};
exports.default = app;
